import { useEffect, useState } from "react";

import { useAppContext } from "@/app/context";

export const useActiveRegistryChangeEffect = (applyEffect: VoidFunction) => {
  const { userSelections } = useAppContext();
  const activeRegistryCode = userSelections?.registry?.registryCode;
  const [activeRegistryCached, setActiveRegistryCached] = useState(activeRegistryCode);

  useEffect(() => {
    if (activeRegistryCode && activeRegistryCode !== activeRegistryCached) {
      setActiveRegistryCached(activeRegistryCode);
      applyEffect();
    }
  }, [activeRegistryCode, activeRegistryCached, applyEffect]);
};
